import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import HappinessTalentSystem from "@/pages/happiness-talent-system/page";
import PersonalGrowth from "@/pages/personal-growth/page";
import CorporateTraining from "@/pages/corporate-training/page";
import Courses from "@/pages/courses/page";
import AiCoach from "@/pages/ai-coach/page";
import Contact from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "about", element: <About /> },
      { path: "happiness-talent-system", element: <HappinessTalentSystem /> },
      { path: "personal-growth", element: <PersonalGrowth /> },
      { path: "corporate-training", element: <CorporateTraining /> },
      { path: "courses", element: <Courses /> },
      { path: "ai-coach", element: <AiCoach /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;